<template>
  <div>
    <artmisads-modal
    v-model:open="visible"
    title="Bulk Update Associate Tags Via CSV"
    @cancel="handleCancel"
    @ok="handleSave"
    okText="save"
    :confirmLoading="saveLoading"
    :maskClosable="false"
    width="900px"
    :footer="null"
  >
    <div>
      <div class="upload-text">
        Upload a CsV fle with the folowing columns, which is specifcally designed to update the Amazon Associate Tags for different Marketplace
      </div>
      <div class="upload-text">
        Please note that Bulk Update Function will not delete any existing tags.
      </div>
      <artmisads-select-button class="download-template" @click="downloadTemplate">
        <Icon name="daochu1" style="margin-right: 8px;"></Icon>
        Download the Template
      </artmisads-select-button>
      <div class="table-container">
        <artmisads-table :columns="columns" :data-source="data" 
        :pagination="false" >
      
      </artmisads-table>
      </div>
      <div class="file-name" v-if="fileName">
        <div>
          <svg class="icon icon-biaoge" aria-hidden="true">
            <use xlink:href="#icon-biaoge"></use>
          </svg>
          <span class="name">{{ fileName }}</span>
          <svg class="icon close-cu" aria-hidden="true" @click="clearFile">
            <use xlink:href="#icon-close-cu"></use>
          </svg>
        </div>
      </div>
      <a-upload name="avatar" list-type="picture-card" :show-upload-list="false" accept=".csv" v-else
        :before-upload="beforeUpload" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <svg class="icon shangchuan2" aria-hidden="true">
          <use xlink:href="#icon-jiahao-cu"></use>
        </svg>
        Choose a file...
      </a-upload>
      <div class="footer">
        <artmisads-button type="primary"
         :loading="uploading"
          :disabled="!fileName"
          @click="handleUploadFile">
          Upload
        </artmisads-button>
      </div>
    </div>
  </artmisads-modal>
  </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { message } from 'ant-design-vue'
import Icon from '~/components/Icon.vue'
import { associateTagsApi } from '@/server/publisher/associateTags'
const emit = defineEmits(['save'])
const visible = ref(false)
const saveLoading = ref(false)
const formData = ref(new FormData())
const fileName = ref('')
const uploading = ref(false)
const handleCancel = () => {
  visible.value = false
}
const columns = ref([
  {
    title: 'amazon.com',
    dataIndex: 'amazon.com',
    align: 'center',
    titleAlign: 'center',
  },
  {
    title: 'amazon.ca',
    dataIndex: 'amazon.ca',
    align: 'center',
    titleAlign: 'center',
  },
  {
    title: 'amazon.de',
    dataIndex: 'amazon.de',
    align: 'center',
    titleAlign: 'center',
  },
  {
    title: 'amazon.fr',
    dataIndex: 'amazon.fr',
    align: 'center',
    titleAlign: 'center',
  },
  {
    title: 'amazon.uk',
    dataIndex: 'amazon.uk',
    align: 'center',
    titleAlign: 'center',
  },
 
])
const data = ref([
  {
    'amazon.com': 'TestTagUS - 20',
    'amazon.ca': 'TestTagCA - 20',
    'amazon.de': 'TestTagDE - 20',
    'amazon.fr': 'TestTagFR - 20',
    'amazon.uk': 'TestTagUK - 20',
  },
  {
    'amazon.com': 'TestTagUS2 - 20',
    'amazon.ca': 'TestTagCA2 - 20',
    'amazon.de': 'TestTagDE2 - 20',
    'amazon.fr': 'TestTagFR2 - 20',
    'amazon.uk': 'TestTagUK2 - 20',
  },
  {
    'amazon.com': 'TestTagUS3 - 20',
    'amazon.ca': 'TestTagCA3 - 20',
    'amazon.de': 'TestTagDE3 - 20',
    'amazon.fr': 'TestTagFR3 - 20',
    'amazon.uk': 'TestTagUK3 - 20',
  }
])
// const handleSave = () => {

//   saveLoading.value = true
//   emit('save')
//   saveLoading.value = false
// }
const handleChange = async ({ file }) => {
  formData.value=new FormData()
  const { type, originFileObj, percent, name } = file
  if (percent === 100) {
    if (type !== 'text/csv') {
      return message.error('Please upload a csv file.')
    } else {
      fileName.value = name
      try {
        formData.value.append('file', originFileObj)
        

      } catch (error) {
        message.error('Upload failed')
      }
    }
  }
}
const downloadTemplate = () => {
  associateTagsApi.downloadAssociateUploadTemplateFile({})
}
const beforeUpload = (file) => {
  const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv')
  if (!isCSV) {
    message.error('You can only upload CSV file!')
    return false
  }
  const isLt50M = file.size / 1024 / 1024 < 10
  if (!isLt50M) {
    message.error('File size exceeds 10MB')
    return false
  }
  return true
}
const handleUploadFile = async () => {
  uploading.value = true

  let res =await associateTagsApi.uploadAssociateTags(formData.value)
  const { success, error, data } = res
  if (success) {
    if(data.success){
      message.success('Bulk Update Successfully!')
      emit('save')
      uploading.value = false
      close()
    }else{
      message.error("File upload failed")
      uploading.value = false
    }

  }
}
const clearFile = () => {
  fileName.value = ''
  // props.setDataList({ successList: [], failList: [] });
}
const open = () => {
  visible.value = true
  fileName.value = ''
}
const close = () => {
  visible.value = false
}
defineExpose({
  open,
  close
})
</script>

<style scoped lang="less">
.download-template{
  margin-top: 6px;
}
.table-container{
  margin-top: 16px;
}
.upload-text{
  color: var(--dark-2);
}
 :deep(.ant-upload-wrapper) {
    margin-top: 8px;

    .ant-upload.ant-upload-select {
      width: 100%;
      height: 64px;
      color: var(--dark-2);
      background: var(--big-bg-1);
      border: 2px dashed var(--border-1);
      border-radius: 8px;
      font-size: var(--font-size-h-l);

      &:hover {
        background: var(--bg-gray-2);
        border: 2px dashed var(--bg-gray-7);
      }

      svg {
        width: 32px;
        height: 32px;
        fill: var(--dark-2);
        margin-right: 16px;
      }
    }
  }
 .footer {
    margin-top: 24px;
    text-align: right;
  }
  .file-name {
    display: flex;
    width: 100%;
    height: 60px;
    cursor: pointer;
    background: var(--big-bg-1);
    border-radius: 8px;
    color: var(--dark-2);
    margin-top: 8px;

    &:hover {
      background: var(--bg-gray-2);
    }

    >div {
      display: flex;
      height: 28px;
      padding: 0 24px;
      border-radius: 8px;
      align-self: center;

      // &:hover {
      //   background-color: var(--bg-gray-4);
      // }
      .icon-biaoge {
        width: 24px;
        height: 24px;
        fill: var(--primary-text);
        align-self: center;
      }

      .name {
        color: var(--primary-text);
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0.4px;
        line-height: 22px;
        margin-left: 8px;
        margin-right: 24px;
        align-self: center;
      }

      .close-cu {
        cursor: pointer;
        width: 24px;
        height: 24px;
        padding: 4px;
        align-self: center;
        fill: var(--dark-3);

        &:hover {
          fill: var(--dark-1);
        }
      }
    }

  }
</style>